"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorFunctionFactoryTermHasLangdir = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
const TermFunctionHasLangdir_1 = require("./TermFunctionHasLangdir");
/**
 * A comunica TermFunctionIsTriple Function Factory Actor.
 */
class ActorFunctionFactoryTermHasLangdir extends bus_function_factory_1.ActorFunctionFactoryDedicated {
    constructor(args) {
        super({
            ...args,
            functionNames: [utils_expression_evaluator_1.SparqlOperator.HAS_LANGDIR],
            termFunction: true,
        });
    }
    async run(_) {
        return new TermFunctionHasLangdir_1.TermFunctionHasLangdir();
    }
}
exports.ActorFunctionFactoryTermHasLangdir = ActorFunctionFactoryTermHasLangdir;
//# sourceMappingURL=ActorFunctionFactoryTermHasLangdir.js.map